export default "__VITE_ASSET__DDkWJeHK__"